import {CompanyEntity, CompanySelectorProps, companyType} from "@ots-frontend/ots-data";
import {CompanySelect, CompanySelectProps} from "./CompanySelect";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {Box, Button, Modal, ModalProps} from "@mantine/core";

type Props = Omit<CompanySelectProps, "selector"> & {
    selector?: Omit<CompanySelectorProps, "companyType">
};

export const TruckCompanySelect = (props: Props) => {
    const {selector, ...rest} = props;

    return (
        <CompanySelect
            {...rest}
            selector={{
                ...selector,
                companyType: companyType.truckCompany
            }}/>
    );
};

export interface TruckCompanySelectModalProps extends Omit<ModalProps, "onSubmit"> {
    select?: Props,
    onSubmit?: (companies: CompanyEntity[] | undefined) => void
}

export const TruckCompanySelectModal = (props: TruckCompanySelectModalProps) => {
    const {
        select,
        onSubmit,
        ...rest
    } = props;

    const [selectedCompanies, setSelectedCompanies] = useState<CompanyEntity[]>([])

    const {t} = useTranslation(["common"]);

    return (
        <Modal {...rest}>
            <Box>
                <TruckCompanySelect
                    {...select}
                    onEntityChange={e => setSelectedCompanies(e)}/>
                <Button type="submit" mt="xl" onClick={(e) => {
                    if (onSubmit) {
                        onSubmit(selectedCompanies);
                    }
                }}>
                    {t("common.action.submit")}
                </Button>
            </Box>
        </Modal>
    );
};
